import React, { useEffect } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useValidateBulletinMutation } from '../../../services/api';
import { useBulletin } from '../../../context/bulletin';
// @ts-expect-error Will convert later
import Loader from '../../Loader/Loader';
import JiraTicketList from './ModalContent/JiraTicketList';

interface ValidationModalProps {
  onClose: () => void;
  show: boolean;
}

function ValidationModal({ show, onClose }: ValidationModalProps) {
  const { bulletinType, bulletinDate } = useBulletin();
  const { data, mutate, isLoading, error } = useValidateBulletinMutation(
    bulletinType,
    bulletinDate,
  );

  useEffect(() => {
    if (show) {
      mutate();
    }
  }, [show, mutate]);

  const hasJiraTickets = data && data.length > 0;

  function getHeader() {
    if (isLoading) {
      return <h2>Validating...</h2>;
    }
    if (error) {
      return <h2>Validation Error</h2>;
    }
    return <h2>Validation Successful</h2>;
  }

  function getContent() {
    if (isLoading) {
      return <Loader>Validating bulletin...</Loader>;
    }
    if (error) {
      return <p>Error validating bulletin</p>;
    }
    if (hasJiraTickets) {
      return <JiraTicketList tickets={data} />;
    }
    return <p>Bulletin Validated successfully.</p>;
  }

  return (
    <Modal
      show={show}
      onHide={isLoading ? undefined : onClose}
      size="lg"
      centered
    >
      <Modal.Header>{getHeader()}</Modal.Header>
      <Modal.Body>{getContent()}</Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          onClick={onClose}
          disabled={isLoading}
        >
          {isLoading && (
            <span style={{ paddingRight: 6 }}>
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </span>
          )}
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ValidationModal;
